















































































































import { Vue, Component } from 'vue-property-decorator';
import Product from '../../common/model/Product';
import brandModule from '../../store/modules/brand.module';
import BrandProductCard from '../../components/brand/BrandProductCard.vue';
import productModule from '../../store/modules/product.module';

@Component({
  components: {
    BrandProductCard,
  },
})
export default class ProductPage extends Vue {
  itemsPerPageArray = [16, 24, 32];

  search = '';

  filter = {};

  sortDesc = false;

  page = 1;

  itemsPerPage = 16;

  sortBy = 'title';

  keys = [
    'Title',
  ];

  get products(): Array<Product> {
    return productModule.products;
  }

  get numberOfPages(): number {
    return Math.ceil(this.products.length / this.itemsPerPage)
  }

  get filteredKeys(): Array<string> {
    return this.keys.filter(key => key !== 'id')
  }

  get brandSecondaryColor(): string {
    if (!brandModule.brand || !brandModule.brand.secondary_color) { return 'black'; }
    return brandModule.brand.secondary_color;
  }

  get brandPrimaryColor(): string {
    if (!brandModule.brand || !brandModule.brand.primary_color) { return 'black'; }
    return brandModule.brand.primary_color;
  }

  nextPage(): void {
    if (this.page + 1 <= this.numberOfPages) this.page += 1
  }

  formerPage(): void {
    if (this.page - 1 >= 1) this.page -= 1
  }

  updateItemsPerPage(number: number): void {
    this.itemsPerPage = number
  }
}
